import { styled } from '@mui/material';

export const ReportsVisitsSectionContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  height: '100%',
  gridAutoRows: 'max-content 1fr',
  flex: 1,
}));

export const ReportsVisitsSectionContent = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: '1fr max(24%, 330px)',
}));
